export const StatutHabilitation = [
  'Visiteur',
  'Membre',
  'Administrateur',
] as const

export type StatutHabilitation = typeof StatutHabilitation[number]

export const StatutHabilitationLibelle: {
  [key in StatutHabilitation]: string
} = {
  Visiteur: 'Visiteur',
  Membre: 'Membre',
  Administrateur: 'Administrateur',
} as const

